export default __webpack_public_path__ + "static/Telecel-Icon-Red-b1af417c4d94fa153bfbdb481dcefd34.png";